/* eslint-disable react/jsx-no-undef */
import React from 'react'
import './sidebar.less'
import { Layout, Image, Dropdown, Menu } from 'antd'
import { DollarCircleFilled, WalletOutlined, SyncOutlined } from '@ant-design/icons'
import { ButtonMenuComponent as ButtonMenu } from '../../components'
import logo from '../../assets/img/logo.png'
import { ReactComponent as IconUsers } from '../../assets/img/people.svg'
import { ReactComponent as IconApprovals } from '../../assets/img/chart-success.svg'
import { ReactComponent as IconExpired } from '../../assets/img/archive.svg'
import { ReactComponent as IconMonitor } from '../../assets/img/monitor.svg'
import { ReactComponent as IconWallet } from '../../assets/img/wallet.svg'
import { ReactComponent as IconMoney } from '../../assets/img/money.svg'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { useAuth } from "../../hooks/useAuth";
import { Button } from "../../components/ui/button";
import { checkAccess } from '../../services/accessControl'

const { Sider } = Layout

const menu = [
    {
        title: 'Clientes',
        key: 'cliente',
        icon: IconUsers,
        link: '/clientes/geral'
    }, {
        title: 'Aprovações',
        key: 'aprovacoes',
        icon: IconApprovals,
        link: '/aprovacoes/aportes'
    }, {
        title: 'Vencidos',
        key: 'vencidos',
        icon: IconExpired,
        link: '/contratos/vencidos'
    }, {
        title: 'Comissões',
        key: 'comissoes',
        icon: DollarCircleFilled,
        link: '/comissoes'
    }, {
        title: 'Saques',
        key: 'saques',
        icon: WalletOutlined,
        link: '/saques'
    }, {
        title: 'Automações',
        key: 'automacoes',
        icon: SyncOutlined,
        link: '/automacoes'
    }
]
// , {
//     title: 'Wallet',
//     key: 'wallet',
//     icon: IconWallet,
//     link: '/wallet/conversoes'
// }
// Definição dos itens do dropdown operacional
const operacionalItems = [
    {
        title: 'Rise Fixed Yield - Classe Sênior',
        key: 'asa',
        link: '/operacional/asa'
    },
    {
        title: 'RFY18 - Classe Sênior',
        key: 'rfy18',
        link: '/operacional/rfy18'
    },
    {
        title: 'Liquidity Yield',
        key: 'spirit',
        link: '/operacional/spirit'
    }
    ,{
        title: 'Rise Fixed Yield - Classe Subordinada',
        key: 'spirit2',
        link: '/operacional/spirit2'
    }
    ,{
        title: 'Rise Liquidity Yield 3',
        key: 'spirit3',
        link: '/operacional/spirit3'
    }
    ,{
        title: 'Capex Senior (1.6%)',
        key: 'capex-senior',
        link: '/operacional/capex-senior'
    }
    ,{
        title: 'Capex Sub (Variável)',
        key: 'capex-sub',
        link: '/operacional/capex-sub'
    }
    ,{
        title: 'BATS',
        key: 'bats',
        link: '/operacional/bats'
    }
    ,{
        title: 'RFY18 - Classe Subordinada',
        key: 'rfy18-subordinada',
        link: '/operacional/rfy18-subordinada'
    }
]

const SidebarComponent = () => {

    const location = useLocation()
    const path = location.pathname
    const { id } = useSelector(state => state.login)
    const { isLoadingNotifications, notifications } = useSelector(state => state.monitors)
    const [isLoading, setIsLoading] = useState(true)
    const [userId, setUserId] = useState(id)
    const { user, signOut } = useAuth();

    const returnNotifications = (type) => {
        if(type === 'aprovacoes') {
            return parseInt(notifications.aportes) + parseInt(notifications.resgates) + parseInt(notifications.spirit) + parseInt(notifications.spirit2) + parseInt(notifications.spirit3 || 0) + parseInt(notifications.bats || 0) + parseInt(notifications.asa)
        } else if(type === 'vencidos') {
            return parseInt(notifications.vencidos)
        } else if(type === 'wallet') {
            return parseInt(notifications.tokens)
        } else if(type === 'cliente') {
            return parseInt(notifications.clientes) + parseInt(notifications.acessos)
        } else if(type === 'saques') {
            return parseInt(notifications.saques)
        }
        else {
            return undefined
        }
    }

    useEffect(() => {
        if(userId === null) {
            setUserId(location.state.id)
        } else {
            setIsLoading(false)
        }
    }, [location, userId])

    useEffect(() => {
        setIsLoading(false)
    }, [userId])

    const [operacionalAllowed, setOperacionalAllowed] = useState(false)
    const [allowedMap, setAllowedMap] = useState({ asa: undefined, rfy18: undefined, 'rfy18-subordinada': undefined, spirit: undefined, spirit2: undefined, spirit3: undefined, 'capex-senior': undefined, 'capex-sub': undefined, bats: undefined })
    const [menuAllowedMap, setMenuAllowedMap] = useState({})

    useEffect(() => {
        let mounted = true
        const load = async () => {
            const [asa, rfy18, rfy18Sub, spirit, spirit2, spirit3, capexSenior, capexSub, bats] = await Promise.all([
                checkAccess(undefined, '/operacional/asa'),
                checkAccess(undefined, '/operacional/rfy18'),
                checkAccess(undefined, '/operacional/rfy18-subordinada'),
                checkAccess(undefined, '/operacional/spirit'),
                checkAccess(undefined, '/operacional/spirit2'),
                checkAccess(undefined, '/operacional/spirit3'),
                checkAccess(undefined, '/operacional/capex-senior'),
                checkAccess(undefined, '/operacional/capex-sub'),
                checkAccess(undefined, '/operacional/bats')
            ])
            if (!mounted) return
            // Exibir grupo se existir ao menos um item permitido (sem exigir permissão do grupo)
            setOperacionalAllowed(Boolean(asa || rfy18 || rfy18Sub || spirit || spirit2 || spirit3 || capexSenior || capexSub || bats))
            setAllowedMap({ asa, rfy18, 'rfy18-subordinada': rfy18Sub, spirit, spirit2, spirit3, 'capex-senior': capexSenior, 'capex-sub': capexSub, bats })
        }
        load()
        return () => { mounted = false }
    }, [])

    // Carregar permissões dos itens de menu principais
    useEffect(() => {
        let mounted = true
        const loadMenu = async () => {
            try {
                const results = await Promise.all(menu.map((i) => checkAccess(undefined, i.link)))
                if (!mounted) return
                const map = {}
                menu.forEach((i, idx) => { map[i.key] = results[idx] })
                setMenuAllowedMap(map)
            } catch (_) {
                // fallback: mantém todos visíveis
            }
        }
        loadMenu()
        return () => { mounted = false }
    }, [])

    // Menu dropdown para Operacional
    const operacionalDropdownMenu = (
        <Menu className="operacional-dropdown-menu">
            {operacionalItems
                .filter((i) => allowedMap[i.key] === true)
                .map((item) => (
                <Menu.Item key={item.key} className="operacional-item">
                    <Link to={item.link}>
                        <div className="dropdown-item-content">
                            <span className="dropdown-item-dot"></span>
                            <span className="dropdown-item-title">{item.title}</span>
                        </div>
                    </Link>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        !isLoading &&
        <Sider className="p-2" width="22vw"
        style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
            <div className="sider-wrapper">
                <div className="user-logged">
                    <img src="/logo-dark.png" alt="Logo" className="user-image" />
                    <div>
                        <h3 className="font-bold tx-blue">
                            {user?.name || 'Bem-vindo'}
                        </h3>
                        <label className="tx-gray">
                            {user?.email || 'Painel de Controle'}
                        </label>
                    </div>
                </div>
                <div className="mt-4">
                    <Button 
                        variant="ghost" 
                        size="icon" 
                        onClick={signOut}
                        className="w-full flex items-center gap-2"
                    >
                        <svg 
                            viewBox="0 0 24 24" 
                            width="1em" 
                            height="1em" 
                            fill="#0b8369" 
                            style={{fill: '#0b8369'}}
                        >
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" 
                                stroke="#0b8369" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                                style={{fill: 'none'}}
                            />
                        </svg>
                        <span style={{color: '#0b8369'}}>Sair</span>
                    </Button>
                </div>
                <div className="sider-menu">
                    {menu.filter((i) => menuAllowedMap[i.key] !== false).map((i, p) => (
                        <Link className={p !== 0 && "mt-15"} to={i.link} key={i.key}><ButtonMenu icon={i.icon} key={i.key} notification={isLoadingNotifications ? undefined : returnNotifications(i.key)} active={path.includes(i.key) ? true : false}>{i.title}</ButtonMenu></Link>
                    ))}
                    
                    {operacionalAllowed && (
                        <div className="mt-15">
                            <Dropdown overlay={operacionalDropdownMenu} trigger={['click']}>
                                <div className="operacional-dropdown">
                                    <ButtonMenu 
                                        icon={IconMonitor}
                                        active={path.includes('operacional')}
                                        className="operacional-btn"
                                    >
                                        Operacional <span className="dropdown-icon">▾</span>
                                    </ButtonMenu>
                                </div>
                            </Dropdown>
                        </div>
                    )}
                </div>
            </div>
        </Sider>
    )
}

export default SidebarComponent